import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { helpPageData } from "../../assets/data/Datas";
import { ChevronRight, User, LockKeyhole, CloudDownload, AppWindowMac } from "lucide-react";

export default function HelpMain() {
    const navigate = useNavigate();
    const helpIcons = [User, LockKeyhole, CloudDownload, AppWindowMac];

    return (
        <Fragment>
            <div className="sticky top-0">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2 z-10">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Help and Support</p>
                </div>
            </div>

            <div className="p-3 bg-white dark:bg-[#1E1D21]">
                <p className="text-[14px] text-black dark:text-white font-semibold mb-2">
                    How can we assist?
                </p>

                <div className="bg-[#BDE6FF] dark:bg-[#333333] rounded-md">
                    {helpPageData.map((data, index) => {
                        const Icon = helpIcons[index % helpIcons.length];
                        return (
                        <div
                            key={index}
                            onClick={() => navigate(`/help/${data.id}`)}
                            className="flex items-center justify-between space-x-3 p-4 border-b border-gray-200 dark:border-gray-800/50 last:border-b-0"
                        >
                            <div className="flex items-center space-x-3">
                                <Icon className="w-4 h-4 text-black dark:text-white" />
                                <span className="text-[14px] text-black dark:text-white">{data.title}</span>
                            </div>
                            <ChevronRight className="w-4 h-4 cursor-pointer text-black dark:text-white" />
                        </div>
                        );
                    })}
                </div>
            </div>
        </Fragment>
    );
}
